import {setTitle} from "@src/util";

export default function (props: { time: string }) {
	const {time} = props;
	console.log(time)
	setTitle('温馨提示')
	return <div className="holiday">
	<p className="title">尊敬的客户：</p>
	<p>感谢长期以来对我们的大力支持！</p>
	<p>在春节即将到来之际，向您致以节日问候，祝您：</p>
	<p>新春愉快，阖家团圆，兔年大吉！</p>
	<p>&nbsp;</p>
	<p>2023年众行金服放假时间为：</p>
	<p>2023年1月20日（星期五）- 2023年1月27日（星期五）</p>
	<p>在此期间众行金服分期系统暂时关闭</p>
	<p>上班时间：1月28日（星期六）</p>
</div>
}